import i18next from 'i18next';

export default function iconName(type) {
  switch (type) {
    case 'GOAL':
      return {
        text: i18next.t('goal'),
        icon: 'footballEvent',
      };
    case 'OWN_GOAL':
      return {
        text: i18next.t('ownGoal'),
        icon: 'ownGoal',
      };
    case 'PENALTY_GOAL':
      return {
        text: i18next.t('goal'),
        icon: 'footballEvent',
      };
    case 'MISSED_PENALTY':
      return {
        text: i18next.t('missedPenalty'),
        icon: 'missedPenalty',
      };
    case 'YELLOW':
      return {
        text: i18next.t('yellowCard'),
        icon: 'yellowCard',
      };
    case 'SECOND_YELLOW':
      return {
        text: i18next.t('doubleYellowCards'),
        icon: 'doubleYellow',
      };
    case 'STRAIGHT_RED':
      return {
        text: i18next.t('redCard'),
        icon: 'redCard',
      };
    case 'POST_MISSED_PENALTY':
      return {
        text: i18next.t('missedPenalty'),
        icon: 'missedPenalty',
      };
    case 'SAVED_MISSED_PENALTY':
      return {
        text: i18next.t('missedPenalty'),
        icon: 'missedPenalty',
      };
    case 'SHOOTOUT_MISSED':
      return {
        text: '',
        icon: 'footballShot',
      };
    case 'SHOOTOUT_SAVED':
      return {
        text: '',
        icon: 'footballShot',
      };
    case 'SHOOTOUT_SCORED':
      return {
        text: '',
        icon: 'footballShot',
      };
    case 'SUBSTITUTION_INJURY':
      return {
        text: i18next.t('substitutionInjury'),
        icon: 'injurySubstitution',
      };
    case 'TACTICAL_SUBSTITUTION':
      return {
        text: i18next.t('substitutionTactical'),
        icon: 'tacticalSubstitution',
      };
    default:
      return {
        text: '',
        icon: 'avatar',
      };
  }
}
